import Vue from "vue";
import VueRouter from "vue-router";
import Vuetify from "vuetify";
//import VueMatomo from 'vue-matomo'
import BootstrapVue from "bootstrap-vue";
import axios from "axios";
import HttpService from "./Http.js";
import VueI18n from "vue-i18n";
import messages from "./assets/messages.json";

import VueNoty from "vuejs-noty";
import "vuetify/dist/vuetify.min.css";
import "vue-cal/dist/vuecal.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// QYSIWYG Editor
import { VueEditor, Quill } from "vue2-editor";
import VueCurrencyInput from "vue-currency-input";
import Multiselect from 'vue-multiselect'
// Vue Components
import ResetPassword from "./components/ResetPassword.vue";
import ForgotPassword from "./components/ForgotPassword.vue";
import Users from "./components/Users.vue";
import Tenants from "./components/Tenants.vue";
import Roles from "./components/Roles.vue";
import Login from "./components/Login.vue";
import Category from "./components/Category.vue";
import Venues from "./components/Venues.vue";
import TrainingTable from "./components/TrainingTable.vue";
import TrainingDetails from "./components/TrainingDetails.vue";
import CategoryTraining from "./components/CategoryTraining.vue";
import TrainingEvents from "./components/TrainingEvents.vue";
import InactiveEvents from "./components/InactiveEvents.vue";
import CreateTrainingEvent from "./components/CreateTrainingEvent.vue";
import CreateTraining from "./components/CreateTraining.vue";
import CreateCategory from "./components/CreateCategory.vue";
import CreateVenue from "./components/CreateVenue.vue";
import CreateTenant from "./components/CreateTenant.vue";
import CreateUser from "./components/CreateUser.vue";
import Imprint from "./components/Imprint.vue";
import Cookies from "./components/Cookies.vue";
import TrainingRequest from "./components/TrainingRequest.vue";
import TrainingRequestOverview from "./components/TrainingRequestOverview.vue";
import ContactForm from "./components/Contact.vue";
import FullCalendarUpdated from "./components/FullCalendarUpdated.vue";
import SalesCalendar from "./components/SalesCalendar.vue";
import OtpVerification from "./components/OtpVerification.vue";
import DownloadDocuments from "./components/DownloadDocuments.vue";
import Trainings from "./components/Trainings.vue";
import PerformanceBoard from "./components/PerformanceBoard.vue";
import Unity from "./components/Unity.vue";

import ContactPersons from "./components/ContactPersons.vue";
import ToolDetails from "./components/ToolDetails.vue";
import OurVenues from "./components/OurVenues.vue";
import Videos from "./components/Videos.vue";
import UploadVideo from "./components/UploadVideo.vue";
import EnterCategoryName from "./components/EnterCategoryName.vue";
import SaveVideo from "./components/SaveVideo.vue";

import AboutUsNew from "./components/AboutUsNew.vue";
import VenueDetails from "./components/VenueDetails.vue";
import UploadApplication from "./components/UploadApplication.vue";
import FeedBackForm from "./components/FeedBackForm.vue";
import TrainingEventCategory from "./components/TrainingEventCategory.vue";
import CreateTrainingEventCategory from "./components/CreateTrainingEventCategory.vue";
import TrainingEventCategoryDetail from "./components/TrainingEventCategoryDetail.vue";

import SalesList from "./components/SalesList.vue";
import SalesRequest from "./components/SalesRequest.vue";
import FeedBackChart from "./components/FeedBackChart.vue";

import ProjectTable from "./components/ProjectTable.vue";
import CreateProject from "./components/CreateProject.vue";

import CreateTargetRevenue from "./components/CreateTargetRevenue.vue";
import ListTargetRevenue from "./components/ListTargetRevenue.vue";

import ManageNewsletter from "./components/ManageNewsletter.vue";
import CreateNewsLetter from "./components/CreateNewsLetter.vue";
import PreviewNewsLetter from "./components/PreviewNewsLetter.vue";
import NewsLetterFront from "./components/NewsLetterFront.vue";
import ConfirmSubscription from "./components/ConfirmSubscription.vue";
import SubscriptionSuccess from "./components/SubscriptionSuccess.vue";
import UnsSubscribeConfirmation from "./components/UnsSubscribeConfirmation.vue";
import UnSubscribeSuccess from "./components/UnSubscribeSuccess.vue";

// Widgets
import Contact from "./components/widget/Contact.vue";
import Share from "./components/widget/Share.vue";
import Upload from "./components/widget/Upload.vue";
import Video from "./components/widget/Video.vue";
import DatePicker from "./components/widget/DatePicker.vue";
import DateRangePicker from "./components/widget/DateRangePicker.vue";
import MultiMonthPicker from "./components/widget/MultiMonthPicker.vue";
import MonthPicker from "./components/widget/MonthPicker.vue";
import BarChartKB from "./components/widget/BarChartKB.vue";
import AppointmentCard from "./components/widget/AppointmentCard.vue";
import RoomAppointmentCard from "./components/widget/RoomAppointmentCard.vue";
import LineChartKB from "./components/widget/LineChartKB.vue";
import Import from "./components/widget/Import.vue";
import TimerWorker from "worker-loader!./workers/timerWorker.js";
import { msalInstance, authService } from "./authService.js"; // Adjust the path as per your project structure
// Main Page
import App from "./views/App.vue";

// Import Quill core styles
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
// import "vue-multiselect/dist/vue-multiselect.min.css";
export const eventBus = new Vue();

Vue.config.productionTip = false;

// Function to load Clarity script
function loadClarity() {
  return new Promise((resolve) => {
    const clarityScript = document.createElement("script");
    clarityScript.type = "text/javascript";
    clarityScript.src = "https://www.clarity.ms/tag/ouse9haact";
    clarityScript.async = true; // Load asynchronously
    clarityScript.onload = () => {
      resolve(); // Resolve the promise when the script is loaded
    };
    document.head.appendChild(clarityScript);
  });
}
loadClarity(); // Load the Clarity script
Vue.use(VueRouter);
// Global Access Variables
Vue.prototype.$axios = HttpService; // axios
Vue.prototype.$rights = []; // User rights
Vue.prototype.$external = true; // User rights
Vue.prototype.$languages = []; // Function for finding flag by language String, e.g. GERMAN
Vue.prototype.$remainingTime = 2 * 60 * 60 * 1000;

const SessionCountdownPlugin = {
  install(Vue) {
    let worker;
    let that = this;
    Vue.prototype.$duration = 2 * 60 * 60 * 1000;
    let duration = 2 * 60 * 60 * 1000;
    Vue.prototype.$startSessionCountdown = () => {
      if (worker) {
        worker.terminate();
      }

      const storedElapsedTime = localStorage.getItem("elapsedTime2");
      if (storedElapsedTime != null) {
        duration = storedElapsedTime;
      } else {
        duration = 2 * 60 * 60 * 1000;
      }

      worker = new TimerWorker();
      worker.postMessage(duration);
      worker.onmessage = (e) => {
        let elapsedTime = duration - e.data;
        localStorage.setItem("elapsedTime2", elapsedTime.toString());
        Vue.prototype.$remainingTime = elapsedTime;
        eventBus.$emit("remaining-time-updated", elapsedTime);
        if (Vue.prototype.$remainingTime === 0) {
          localStorage.removeItem("elapsedTime2");
          worker.terminate();
          fetch("/logout", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({}),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              // Redirect after successful logout
              window.location.href = "/login";
            })
            .catch((error) => {
              console.error("Logout failed:", error);
            });

          return;
        }
      };
    };

    Vue.prototype.$destroyTimer = () => {
      localStorage.removeItem("elapsedTime2");
      worker.terminate();
    };

    Vue.prototype.$resetSessionTimer = () => {
      if (worker) {
        worker.terminate();
      }
      localStorage.removeItem("elapsedTime2");
      worker = new TimerWorker();
      let durationNew = 2 * 60 * 60 * 1000;

      worker.postMessage(durationNew);
      worker.onmessage = (e) => {
        let elapsedTimeReset = durationNew - e.data;
        localStorage.setItem("elapsedTime2", elapsedTimeReset.toString());
        Vue.prototype.$remainingTime = elapsedTimeReset;
        eventBus.$emit("remaining-time-updated", elapsedTimeReset);
      };
      //console.log("reset-timer");
    };
  },
};

Vue.use(SessionCountdownPlugin);

// Use base Components
Vue.use(BootstrapVue);
Vue.use(Vuetify);
Vue.use(VueEditor /* { default global options} */);
Vue.component("vue-editor", VueEditor);
const pluginOptions = {
  globalOptions: {
    currency: "EUR",
    locale: "en-US",
    distractionFree: false,
    valueAsInteger: false,
  },
};

Vue.use(VueCurrencyInput, pluginOptions);
Vue.use(Multiselect);

// Components
Vue.use(Unity);
Vue.use(ResetPassword);
Vue.use(Users);
Vue.use(Tenants);
Vue.use(Category);
Vue.use(TrainingTable);
Vue.use(TrainingDetails);
Vue.use(Login);
Vue.use(ResetPassword);
Vue.use(Venues);
Vue.use(TrainingEvents);
Vue.use(InactiveEvents);
Vue.use(CreateTrainingEvent);
Vue.use(FeedBackForm);
Vue.use(Trainings);
Vue.use(CategoryTraining);
Vue.use(Videos);
Vue.use(UploadVideo);
Vue.use(EnterCategoryName);
Vue.use(SaveVideo);
Vue.use(TrainingEventCategory);
Vue.use(CreateTrainingEventCategory);
Vue.use(FeedBackChart);

Vue.use(SalesList);
Vue.use(SalesRequest);
Vue.use(PerformanceBoard);
Vue.use(ProjectTable);
Vue.use(CreateProject);
Vue.use(TrainingEventCategoryDetail);

Vue.use(ManageNewsletter);
Vue.use(CreateNewsLetter);
Vue.use(PreviewNewsLetter);
Vue.use(NewsLetterFront);
Vue.use(ConfirmSubscription);
Vue.use(SubscriptionSuccess);
Vue.use(UnsSubscribeConfirmation);
Vue.use(UnSubscribeSuccess);

// Widgets
Vue.use(Contact);
Vue.component("Contact", Contact);
Vue.use(Share);
Vue.component("Share", Share);
Vue.use(Upload);
Vue.component("Upload", Upload);
Vue.use(Video);
Vue.component("Video", Video);
Vue.use(DatePicker);
Vue.component("DatePicker", DatePicker);
Vue.use(MonthPicker);
Vue.component("MonthPicker", MonthPicker);
Vue.use(MultiMonthPicker);
Vue.component("MultiMonthPicker", MultiMonthPicker);
Vue.use(BarChartKB);
Vue.component("BarChartKB", BarChartKB);
Vue.use(LineChartKB);
Vue.component("LineChartKB", LineChartKB);
Vue.use(AppointmentCard);
Vue.component("AppointmentCard", AppointmentCard);
Vue.use(RoomAppointmentCard);
Vue.component("RoomAppointmentCard", RoomAppointmentCard);
Vue.use(Import);
Vue.component("Import", Import);

Vue.use(DateRangePicker);
Vue.component("DateRangePicker", DateRangePicker);

// Language
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: "de",
  messages,
});

// Vuetify
const vuetifyOpts = {
  theme: {
    themes: {
      light: {
        primary: "#0069AE",
        secondary: "#003A61",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FB8C00",
        grey: "#2f2f2f",
      },
    },
  },
};
const vuetify = new Vuetify(vuetifyOpts);
// Initialize VueMatomo

// Vue Router
const router = new VueRouter({
  routes: [
    {
      path: "/",
      component: Category,
      meta: { breadcrumb: "Home" },
    },
    {
      path: "/subscribe-module",
      component: NewsLetterFront,
      meta: { breadcrumb: "newsletter_subscription" },
    },
    {
      path: "/unsubscribe",
      component: UnsSubscribeConfirmation,
      meta: { breadcrumb: "newsletter_subscription" },
    },
    {
      path: "/unsubscribe-success",
      component: UnSubscribeSuccess,
      meta: { breadcrumb: "newsletter_subscription" },
    },
    {
      path: "/subscription-success",
      component: SubscriptionSuccess,
      meta: { breadcrumb: "newsletter_subscription" },
    },
    {
      path: "/confirm-subscription",
      component: ConfirmSubscription,
      meta: { breadcrumb: "newsletter_subscription" },
    },
    {
      path: "/login",
      component: Login,
      props: (route) => ({ routingTarget: route.query.routingTarget }),
    },
    {
      path: "/users",
      component: Users,
      meta: { breadcrumb: "user management" },
    },
    { path: "/unity", component: Unity, meta: { breadcrumb: "digitalTwin" } },
    { path: "/tenants", component: Tenants, meta: { breadcrumb: "tenants" } },
    {
      path: "/sales-calendar",
      component: SalesCalendar,
      meta: { breadcrumb: "schedule overview" },
    },
    { path: "/venues", component: Venues, meta: { breadcrumb: "venues" } },
    { path: "/roles", component: Roles },
    { path: "/categories", component: Category },
    { path: "/category/:pathMatch(.*)*", component: TrainingTable },
    { path: "/category-training/:pathMatch(.*)*", component: CategoryTraining },
    {
      path: "/create-training",
      component: CreateTraining,
      props: (route) => ({ categoryName: route.query.category }),
      meta: { breadcrumb: "create_training" },
    },
    {
      path: "/edit-training",
      component: CreateTraining,
      props: (route) => ({ trainingId: route.query.trainingId }),
      meta: { breadcrumb: "edit_training" },
    },
    {
      path: "/create-category",
      component: CreateCategory,
      meta: { breadcrumb: "create_category" },
    },
    {
      path: "/edit-category",
      component: CreateCategory,
      props: (route) => ({ categoryId: route.query.categoryId }),
      meta: { breadcrumb: "edit_category" },
    },
    { path: "/training/:pathMatch(.*)*", component: TrainingDetails },
    {
      path: "/training-events:pathMatch(.*)*",
      component: TrainingEvents,
      meta: { breadcrumb: "trainingevents" },
    },
    {
      path: "/inactive-events:pathMatch(.*)*",
      component: InactiveEvents,
      meta: { breadcrumb: "inactiveEvents" },
    },
    { path: "/trainings:pathMatch(.*)*", component: Trainings },
    {
      path: "/create-training-event",
      component: CreateTrainingEvent,
      props: (route) => ({ trainingRequestId: route.query.trainingRequestId }),
      meta: { breadcrumb: "create_trainingEvent" },
    },
    {
      path: "/edit-training-event",
      component: CreateTrainingEvent,
      props: (route) => ({ trainingEventId: route.query.trainingEventId }),
      meta: { breadcrumb: "edit_trainingEvent" },
    },
    {
      path: "/create-venue",
      component: CreateVenue,
      meta: { breadcrumb: "create_venue" },
    },
    {
      path: "/edit-venue",
      component: CreateVenue,
      props: (route) => ({ venueId: route.query.venueId }),
      meta: { breadcrumb: "edit_venue" },
    },
    {
      path: "/create-tenant",
      component: CreateTenant,
      meta: { breadcrumb: "create_tenant" },
    },
    {
      path: "/edit-tenant",
      component: CreateTenant,
      props: (route) => ({ tenantId: route.query.tenantId }),
      meta: { breadcrumb: "edit_tenant" },
    },
    {
      path: "/create-user",
      component: CreateUser,
      meta: { breadcrumb: "create_user" },
    },
    {
      path: "/edit-user",
      component: CreateUser,
      props: (route) => ({ userId: route.query.userId }),
      meta: { breadcrumb: "edit_user" },
    },
    { path: "/forgot-password", component: ForgotPassword },
    {
      path: "/reset-password",
      component: ResetPassword,
      props: (route) => ({
        token: route.query.token,
        newUser: route.query.newUser,
      }),
    },
    {
      path: "/calendar",
      component: FullCalendarUpdated,
      meta: { breadcrumb: "schedule overview" },
    },
    { path: "/otp-verification:pathMatch(.*)*", component: OtpVerification },
    { path: "/feedback-form:pathMatch(.*)*", component: FeedBackForm },
    {
      path: "/download-documents:pathMatch(.*)*",
      component: DownloadDocuments,
    },
    { path: "/feedback-charts:pathMatch(.*)*", component: FeedBackChart },
    {
      path: "/contactpersons",
      component: ContactPersons,
      meta: { breadcrumb: "contactpersons" },
    },
    {
      path: "/request",
      component: TrainingRequest,
      props: (route) => ({
        trainingId: route.query.trainingId,
        trainingRequestId: route.query.trainingRequestId,
      }),
      meta: { breadcrumb: "create_training_request" },
    },
    {
      path: "/training-requests",
      component: TrainingRequestOverview,
      meta: { breadcrumb: "training_requests" },
    },
    { path: "/imprint", component: Imprint, meta: { breadcrumb: "imprint" } },
    { path: "/cookies", component: Cookies, meta: { breadcrumb: "cookies" } },
    {
      path: "/ourvenues",
      component: OurVenues,
      meta: { breadcrumb: "venues" },
    },
    {
      path: "/aboutus",
      component: AboutUsNew,
      meta: { breadcrumb: "aboutus" },
    },
    { path: "/videos", component: Videos, meta: { breadcrumb: "videos" } },
    {
      path: "/uploadvideo",
      component: UploadVideo,
      meta: { breadcrumb: "videos" },
    },
    {
      path: "/enter_category_name",
      component: EnterCategoryName,
      meta: { breadcrumb: "video_category_name" },
    },
    {
      path: "/save_video:pathMatch(.*)*",
      component: SaveVideo,
      meta: { breadcrumb: "upload_videos" },
    },
    {
      path: "/edit_video:pathMatch(.*)*",
      component: SaveVideo,
      meta: { breadcrumb: "edit_video" },
    },
    {
      path: "/edit-category-name:pathMatch(.*)*",
      component: EnterCategoryName,
      meta: { breadcrumb: "edit_category" },
    },

    {
      path: "/venue",
      component: VenueDetails,
      props: (route) => ({ venueId: route.query.venueId }),
    },
    { path: "/tools/:pathMatch(.*)*", component: ToolDetails },
    { path: "/offers/:pathMatch(.*)*", component: ToolDetails },
    {
      path: "/contact",
      component: ContactForm,
      meta: { breadcrumb: "contact" },
    },
    {
      path: "/upload-application",
      component: UploadApplication,
      meta: { breadcrumb: "upload-application" },
    },
    {
      path: "/performance-board",
      component: PerformanceBoard,
      meta: { breadcrumb: "performance-board" },
    },
    {
      path: "/training-event-category-list:pathMatch(.*)*",
      component: TrainingEventCategory,
      meta: { breadcrumb: "training_event_categorys" },
    },
    {
      path: "/training-event-category:pathMatch(.*)*",
      component: CreateTrainingEventCategory,
      meta: { breadcrumb: "create_training_event_category" },
    },

    {
      path: "/sales-list",
      component: SalesList,
      meta: { breadcrumb: "sales-list" },
    },
    {
      path: "/sales-request:pathMatch(.*)*",
      component: SalesRequest,
      meta: { breadcrumb: "create-sales-list" },
    },
    {
      path: "/performance-board",
      component: PerformanceBoard,
      props: (route) => ({
        yearTP: route.query.yearTP,
        monthTP: route.query.monthTP,
      }),
      meta: { breadcrumb: "performance-board" },
    },
    {
      path: "/create-project",
      component: CreateProject,
      meta: { breadcrumb: "create_project" },
    },
    {
      path: "/edit-project",
      component: CreateProject,
      props: (route) => ({ projectId: route.query.projectId }),
      meta: { breadcrumb: "project_edit" },
    },
    {
      path: "/projects",
      component: ProjectTable,
      meta: { breadcrumb: "projects" },
    },
    {
      path: "/upload-video",
      component: UploadVideo,
      props: (route) => ({ videoCategoryId: route.query.videoCategoryId }),
      meta: { breadcrumb: "videos" },
    },
    {
      path: "/category-details:pathMatch(.*)*",
      component: TrainingEventCategoryDetail,
    },
    {
      path: "/create-target-revenue",
      component: CreateTargetRevenue,
      meta: { breadcrumb: "create_TR" },
    },
    {
      path: "/edit-target-revenue",
      component: CreateTargetRevenue,
      props: (route) => ({
        trainer_target_revenue_id: route.query.trainer_target_revenue_id,
      }),
      meta: { breadcrumb: "edit_TR" },
    },
    {
      path: "/list-target-revenue",
      component: ListTargetRevenue,
      meta: { breadcrumb: "list-target-revenue" },
    },
    {
      path: "/manage-newsletter",
      component: ManageNewsletter,
      meta: { breadcrumb: "manage_newsletter" },
    },
    {
      path: "/create-news-letter",
      component: CreateNewsLetter,
      meta: { breadcrumb: "compose_newsletter" },
    },
    {
      path: "/edit-news-letter:pathMatch(.*)*",
      component: CreateNewsLetter,
      meta: { breadcrumb: "compose_newsletter" },
    },
    {
      path: "/preview-news-letter:pathMatch(.*)*",
      component: PreviewNewsLetter,
      meta: { breadcrumb: "compose_newsletter" },
    },
  ],
  mode: "history",
});
router.afterEach((to, from) => {
  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/ouse9haact"; // Replace with your actual Project ID
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", "ouse9haact");
  const checkClarity = () => {
    if (typeof window.clarity !== "undefined") {
      window.clarity("set", "pageName", to.path);
      window.clarity("trackPageview");
    } else {
      setTimeout(checkClarity, 100); // Check again after 100ms
    }
  };

  checkClarity();
});

window.Vue = Vue;
router.beforeEach((to, from, next) => {
  if (to.path.startsWith("/inactive-events")) {
    const urlParams = new URLSearchParams(to.fullPath.split("?")[1]);
    const eventStatus = urlParams.get("eventStatus");

    if (eventStatus) {
      const breadcrumb = eventStatus.replace(/-/g, " ");
      if (breadcrumb == "cancelled") {
        to.meta.breadcrumb = "cancelledtrainingevents";
      } else if (breadcrumb == "drafted") {
        to.meta.breadcrumb = "draftedTrainingEvents";
      } else if (breadcrumb == "archived") {
        to.meta.breadcrumb = "archivedTrainingEvents";
      }
    } else {
      to.meta.breadcrumb = "Inactive Events";
    }
  }

  if (to.path.startsWith("/request")) {
    const urlParams = new URLSearchParams(to.fullPath.split("?")[1]);
    const trainingId = urlParams.get("trainingRequestId");
    if (urlParams.size > 0 && trainingId) {
      to.meta.breadcrumb = "edit_training_request";
    }
  }

  if (to.path.startsWith("/sales-request")) {
    const urlParams = new URLSearchParams(to.fullPath.split("?")[1]);
    const trainingRequestId = urlParams.get("salesListId");
    if (urlParams.size > 0 && trainingRequestId) {
      to.meta.breadcrumb = "edit-sales-list";
    }
  }

  if (to.path.startsWith("/tools")) {
    const toolParts = to.path.split("/").filter((part) => part);
    const lastPart = toolParts[toolParts.length - 1];
    const breadcrumb = lastPart.replace(/-/g, " ");
    to.meta.breadcrumb = `${breadcrumb}`;
  }

  if (to.path.startsWith("/offers")) {
    const toolParts = to.path.split("/").filter((part) => part);
    const lastPart = toolParts[toolParts.length - 1];
    const breadcrumb = lastPart.replace(/-/g, " ");
    to.meta.breadcrumb = `${breadcrumb}`;
  }

  next();
});
// Vue.use(VueMatomo, {
//   router,
//   host: 'https://knorrbremsetrainingfrontend.matomo.cloud/',
//    siteId: 1,
//   // Other configuration options
// });

Object.defineProperty(Vue.prototype, "$locale", {
  get: function () {
    return i18n.locale;
  },
  set: function (locale) {
    i18n.locale = locale;
  },
});

// Notifications
Vue.use(VueNoty, {
  timeout: 6000,
  progressBar: true,
  killer: true,
  layout: "topRight",
  closeWith: ["click", "button"],
});

function getQueryParam(searchWord, query) {
  const searchWordPosition = query.indexOf(searchWord);

  if (searchWordPosition >= 0) {
    const start = searchWordPosition + searchWord.length;

    const separatorPosition = query.indexOf("&", start);
    const end = separatorPosition === -1 ? query.length : separatorPosition;

    return query.substr(start, end - start);
  }
  return "";
}

// Global Methods
Vue.prototype.$formatDate = function (dateStr) {
  const date = new Date(dateStr);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
};
Vue.prototype.$formatDateTime = function (dateStr) {
  return new Date(dateStr).toLocaleDateString(navigator.languages, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

Vue.prototype.$routerPush = function (path, right, elsePath = null) {
  if (this.$rights.includes(right)) {
    this.$router.push(path);
  } else if (elsePath != null) {
    this.$router.push(elsePath);
  }
};

Vue.prototype.$routerBack = function () {
  this.$router.go(-1);
  if (this.$router.currentRoute.path.includes("login")) {
    this.$router.go(-1);
  }
};

Vue.prototype.$isStringEmptyOrNull = function (value) {
  return value === null || value === undefined || value.trim() === "";
};

/**
 * Converts the given HTMLText to a sendable format (when convertBack is false, default) or converts the given Text from its sendable format back to HTML Format
 * @param {*} htmlText
 * @param {*} convertBack
 */
Vue.prototype.$convertHtml = function (htmlText, convertBack = false) {
  // Important: Changes here need to be synchronized with Method in MiscUtil.java in Backend
  // const prefix = "KB_HTML_CONVERT_CG_";
  // const params = {
  //   '<p class="ql-indent-1">': prefix + "P_INDENT_1",
  //   '<p class="ql-indent-2">': prefix + "P_INDENT_2",
  //   '<p class="ql-indent-3">': prefix + "P_INDENT_3",
  //   '<p class="ql-indent-4">': prefix + "P_INDENT_4",
  //   '<p class="ql-indent-5">': prefix + "P_INDENT_5",
  //   '<p class="ql-indent-6">': prefix + "P_INDENT_6",
  //   '<p class="ql-indent-7">': prefix + "P_INDENT_7",
  //   '<p class="ql-indent-8">': prefix + "P_INDENT_8",
  //   "</p>": prefix + "P_CLOSE",
  //   "<p>": prefix + "P_OPEN",
  //   "<br>": prefix + "BR",
  //   "<br />": prefix + "BR",
  //   "</b>": prefix + "B_CLOSE",
  //   "<b>": prefix + "B_OPEN",
  //   "</u>": prefix + "U_CLOSE",
  //   "<u>": prefix + "U_OPEN",
  //   "</i>": prefix + "I_CLOSE",
  //   "<i>": prefix + "I_OPEN",
  //   "</ol>": prefix + "OL_CLOSE",
  //   "<ol>": prefix + "OL_OPEN",
  //   "</ul>": prefix + "UL_CLOSE",
  //   "<ul>": prefix + "UL_OPEN",
  //   "</li>": prefix + "LI_CLOSE",
  //   "<li>": prefix + "LI_OPEN",
  //   "</strong>": prefix + "STRONG_CLOSE",
  //   "<strong>": prefix + "STRONG_OPEN",
  //   "<em>": prefix + "EM_OPEN",
  //   "</em>": prefix + "EM_CLOSE",
  //   "<html>": prefix + "HTML_OPEN",
  //   "</html>": prefix + "HTML_CLOSE",
  //   "<body>": prefix + "BODY_OPEN",
  //   "</body>": prefix + "BODY_CLOSE",
  // };
  // for (const [key, value] of Object.entries(params)) {
  //   if(htmlText){
  //     if (!convertBack) {
  //       htmlText = htmlText.replaceAll(key, value);
  //     } else {
  //       htmlText = htmlText.replaceAll(value, key);
  //     }
  //   }
  // }

  if (htmlText) {
    return htmlText;
  } else {
    return "";
  }
};

/**
 * Uses the convertHtml Function to convert all values in the given DescriptionText Set
 * @param {*} descriptionText
 * @param {*} convertBack
 * @returns
 */
Vue.prototype.$convertHtmlDescriptionText = function (
  descriptionText,
  convertBack = false
) {
  // for (const [key, value] of Object.entries(descriptionText)) {
  //   descriptionText[key] = this.$convertHtml(value, convertBack);
  //   descriptionText[key] = descriptionText[key].replace(/<.*?>/g, "");
  // }
  if (descriptionText) {
    return descriptionText;
  } else {
    return "";
  }
};

new Vue({
  render: (h) => h(App),
  components: { App, Contact, Share, BarChartKB, LineChartKB },
  i18n,
  router,
  vuetify,
  watch: {
    $route(to, from) {
      window.scrollTo(0, 0);
    },
  },
  data: function () {
    return {
      languageTabsNew: [],
      selectableLanguagesAll: [], // Define languageTabs as a reactive property
    };
  },
  beforeCreate: function () {
    if (
      window.location.href.includes("?lang") &&
      !(this.$route.path == "/training-event-category-list") &&
      !(this.$route.path == "/training-events") &&
      !(this.$route.path == "/training-event-category") &&
      !(this.$route.path == "/categories") &&
      !(this.$route.path == "/videos") &&
      !(this.$route.path == "/request") &&
      !(this.$route.path == "/create-training-event") &&
      !(this.$route.path == "/venues") &&
      !(this.$route.path == "/uploadvideo") &&
      !(this.$route.path == "/") &&
      !(this.$route.path == "/training-events-new") &&
      !(this.$route.path == "/table-changes") &&
      !(this.$route.path == "/category-details") &&
      !(this.$route.path == "/edit-training-event?trainingEventId=") &&
      !(this.$route.path == "/manage-newsletter") &&
      !(this.$route.path == "/subscribe-module") &&
      !(this.$route.path == "/confirm-subscription") &&
      !(this.$route.path == "/edit-news-letter?newsLetterId=") &&
      !(this.$route.path == "/create-news-letter") &&
      !(this.$route.path == "/preview-news-letter?newsLetterId=")
    ) {
      window.location.href = window.location.href.substring(
        0,
        window.location.href.indexOf("?")
      );
    }
    if (window.location.href.includes("%3Flang")) {
      window.location.href = window.location.href.substring(
        0,
        window.location.href.indexOf("%3Flang")
      );
    }
  },

  updated() {
    this.$locale = this.$locale;
  },
  beforeMount: function () {
    var _this = this;
    this.$axios
      .get("/api/user/me")
      .then(function (response) {
        const user = response.data;
        Vue.prototype.$user = user;
        Vue.prototype.$rights = user.allRights;
        Vue.prototype.$external = user.external;
      })
      .catch(function (error) {
        // Check current window Location and check if Authorized
        console.error(error);

        _this.checkWindowLocationAndRouteToLogin();
      });

    /* this.$axios
      .get("/api/language/me")
      .then(function (response) {
        const selectedlanguage = response.data.shortForm;
      //  Vue.prototype.$language = response.data;
       // _this.$locale = selectedlanguage.toLowerCase();
      })
      .catch(function (error) {
        console.error(error);
      });*/

    var languageTabs = [];

    this.$axios
      .get("/api/language/all")
      .then(function (response) {
        Vue.prototype.$languages = response.data;
        const languages = response.data;
        const lnlist = [];
        for (var i in languages) {
          var language = {
            key: languages[i].language,
            name: languages[i].language,
            translatedName: languages[i].translatedName,
            flag: languages[i].flag,
            shortForm: languages[i].shortForm,
            onlySelectable: languages[i].onlySelectable,
          };
          if (!languages[i].onlySelectable) {
            languageTabs.push(languages[i]);
            _this.languageTabsNew.push(languages[i]);
          }
          lnlist.push(language);
        }

        Vue.prototype.$selectableLanguages = lnlist;
        Vue.prototype.$languageTabs = languageTabs;
      })
      .catch(function (error) {
        console.error(error);
      });
  },
  mounted() {
    // // Ensure the user is logged in before attempting token acquisition
    // if (!authService.getAccount()) {
    //   // Example: Redirect the user to login
    //   authService.login(window.location.href);
    // } else {
    //   // Example: Fetch access token if user is logged in
    //   fetchAccessToken();
    // }
  },
  methods: {
    setUser(user) {
      this.user = user;
    },
    //  async fetchAccessToken() {
    //     try {
    //         const accessToken = await authService.acquireToken();
    //         console.log("Access token:", accessToken);
    //         // Proceed with API calls or other actions requiring the access token
    //     } catch (error) {
    //         console.error("Failed to acquire token:", error);
    //         // Handle error appropriately
    //     }
    // },

    checkWindowLocationAndRouteToLogin() {
      var location = window.location.href;
      if (location.startsWith("http://") || location.startsWith("https://"))
        location = location.substring(location.indexOf("//") + 2);
      const allowedRoutes = [
        "/login",
        "/forgot-password",
        "/reset-password",
        "/categories",
        "/category/",
        "/tools",
        "/offers",
        "contactpersons",
        "/ourvenues",
        "/aboutus",
        "/venue?venueId",
        "/request",
        "/contact",
        "/imprint",
        "/training/",
        "/cookies",
        "/trainings",
        "otp-verification",
        "/download-documents",
        "/feedback-form",
        "/videos",
        "/uploadvideo",
        "/category-details",
        "/",
        "/venues",
      ];
      const unallowedRoutes = [
        "/request?trainingRequestId",
        "/sales-request?trainingRequestId=",
        "/sales-list",
        "/sales-request?salesListId=",
        "/performance-board",
        "/list-target-revenue",
        "/create-target-revenue",
        "/edit-target-revenue?trainer_target_revenue_id=",
        "/list-trainer-productivity",
        "/list-room-forecast",
        "/create-room-forecast",
        "/edit-room-forecast?room_forecast_id=",
        "/list-target-revenue",
        "/edit-target-revenue?trainer_target_revenue_id=",
        "/create-target-revenue",
        "/projects",
        "/create-project",
        "/edit-project?projectId=",
        "/training-requests",
        "/edit-venue?venueId=",
        "create-venue",
        "/uploadvideo",
        "/enter_category_name",
        "/save_video?selectedCategory=",
        "/edit-category-name?categoryId=",
        "/edit_video?videoId=",
        "/tenants",
        "/edit-tenant?tenantId=",
        "/create-tenant",
        "/calendar",
        "/sales-calendar",
        "/users",
        "/create-user",
        "/edit-user?userId=",
        "/training-events",
        "/inactive-events?eventStatus=",
        "/edit-training-event?trainingEventId=",
        "/edit-training-event?trainingEventId=",
        "/training-event-category",
        "/training-event-category?trainingeventcategoryId=",
        "/create-training?category",
        "/create-category",
        "/edit-category?categoryId=",
        "/create-training?category=",
        "/edit-training?trainingId=",
        "/manage-newsletter",
      ];
      var routeAllowed = false;

      // Check allowedRoutes
      for (let i = 0; i < allowedRoutes.length; i++) {
        const allowedRoute = allowedRoutes[i];
        if (location.includes(allowedRoute)) {
          routeAllowed = true;
          break;
        }
      }
      // Check unallowedRoutes
      for (let i = 0; i < unallowedRoutes.length; i++) {
        const unallowedRoute = unallowedRoutes[i];
        if (location.includes(unallowedRoute)) {
          routeAllowed = false;
          break;
        }
      }
      if (!location.includes("/")) return; // Start Page always allowed
      if (routeAllowed) return;

      const unallowedRoute = location.substring(location.indexOf("/"));
      if (unallowedRoute == "/") return; // Start Page always allowed
      this.$router.push("/login?routingTarget=" + unallowedRoute);
    },
  },
}).$mount("#app");

// router.beforeEach((to, from, next) => {
//   Vue.prototype.$matomo.trackPageView(to.fullPath)
//   next()
// })
